import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import AgesSection from '../components/AgesSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Home = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Dagbesteding & Logeeropvang"
        description="Dagbesteding en logeeropvang voor jeugd 3-18 jaar met ASS, ADHD of beperking. 1-op-1 begeleiding in Nieuwstadt. Bel 06-19199023."
        keywords="dagbesteding, logeeropvang, jeugdzorg, ASS, ADHD, Nieuwstadt, KS Care"
        
      />
      <Header />
      <Hero />
      <AboutSection />
      <AgesSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Home;